import { Controller } from "@hotwired/stimulus"

const CHARSET = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789"
const LENGTH = 20

export default class extends Controller {
  static targets = ["password", "confirmation", "display"]

  generate(event) {
    event.preventDefault()
    const password = this.#randomString(LENGTH)
    this.passwordTarget.value = password
    this.confirmationTarget.value = password
    this.displayTarget.textContent = password
    this.displayTarget.closest("[data-password-suggester-display-wrapper]").classList.remove("hidden")
  }

  #randomString(length) {
    const arr = new Uint32Array(length)
    crypto.getRandomValues(arr)
    return Array.from(arr, (n) => CHARSET[n % CHARSET.length]).join("")
  }
}